var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoBjPush(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "0 0 19 19",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.813,
    cy: 9,
    r: 9,
    fill: "#FFA902"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.662 4.43q1.89 0 2.754.769.864.756.864 2.12 0 .606-.203 1.16a2.6 2.6 0 0 1-.634 1q-.445.431-1.188.688-.73.243-1.796.243H8.42v3.658H6.963V4.43zm-.108 1.228H8.42V9.18h.877q.824 0 1.377-.175.555-.19.824-.58.283-.405.283-1.054 0-.864-.54-1.282-.526-.432-1.687-.432"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBjPush);
export default __webpack_public_path__ + "static/media/IcoBJPush.b19b12001b327c1b9bb74350e7a38b2a.svg";
export { ForwardRef as ReactComponent };